import omit from 'lodash/omit';
import sha256 from 'crypto-js/sha256';

function replacer(key: string, value: any) {
  if (key === 'BetPositionLabel') return '';
  return value;
}
export function getBetRequestId(singleBetRequest: any) {
  let obj = JSON.parse(JSON.stringify(singleBetRequest, replacer)) as any;
  if (obj?.hasOwnProperty('BetterOdds')) {
    // @ts-ignore
    delete obj.BetterOdds;
  }

  // pick specific properties that are needed for the hash
  obj.BetArgs = {
    MatchID: obj.BetArgs.MatchID,
    SpecialValue: Math.abs(obj.BetArgs.SpecialValue),
    BetPosition: obj.BetArgs.BetPosition,
    BetType: obj.BetArgs.BetType,
    IsFH: obj.BetArgs.IsFH,
  };

  let uniqId = `m-${obj.BetArgs.MatchID}_s-${obj.BetArgs.SpecialValue}_bp-${obj.BetArgs.BetPosition}_bt-${
    obj.BetArgs.BetType
  }${obj.BetArgs.IsFH ? '_fh' : ''}`;

  // if (!stop && obj.BetArgs.OddsValue === 0.17) console.trace('get id', obj, sha256(JSON.stringify(obj)).toString());

  // return sha256(JSON.stringify(obj)).toString();
  return uniqId;
}
